<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <app-list-header [title]="'Organization'" [$parent]="getSelf()">
      </app-list-header>
    </div>

    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <!-- table form -->
              <div class="table-responsive mb-3">
                <table id="dataTableId" class="table">
                  <thead class="table-light">
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Description</th>
                      <th>Info</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let e of form.list; let i = index">
                      <td>{{ pageIndex(i) }}</td>
                      <td>
                        {{ e.name }}
                      </td>
                      <td>{{ e.phone }}</td>
                      <td>
                        {{ e.address }}
                      </td>
                      <td>
                        <app-info-button [ele]="e"></app-info-button>
                      </td>
                      <td>
                        <div class="d-flex order-actions">
                          <a title="Edit" data-bs-toggle="modal" data-bs-target="#editModal" (click)="get(e.id)"><i
                              class="fa fa-edit"></i></a>
                          <a title="Delete" title="Delete" class="ms-1" (click)="delete(e.id)"><i
                              class="fa fa-trash"></i></a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <app-list-header [$parent]="getSelf()"></app-list-header>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- data entry form -->
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Organization</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>
      <div class="modal-body">
        <form #uiForm="ngForm">
          <p>
            <form-error [form]="form"></form-error>
          </p>
          <div class="row mb-3">
            <label for="name" class="col-sm-3 col-form-label">Name </label>
            <div class="col-sm-9">
              <input id="name" name="name" placeholder="Name" type="text" class="form-control form-control-sm" required
                [(ngModel)]="form.data['name']" />
            </div>
          </div>

          <div class="row mb-3">
            <label for="phone" class="col-sm-3 col-form-label">Phone </label>
            <div class="col-sm-9">
              <input
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                type="number" [pattern]="mobNumberPattern" class="form-control form-control-sm" id="phone" name="phone"
                [(ngModel)]="form.data['phone']" placeholder="Enter Contact Number" maxlength="10" minlength="10"
                required title="Please enter valid phone number" #phone="ngModel" />
            </div>
          </div>

          <div class="row mb-3">
            <label for="address" class="col-sm-3 col-form-label">Description</label>
            <div class="col-sm-9">
              <textarea id="address" name="address" placeholder="Description" type="text"
                class="form-control form-control-sm" rows="2" [(ngModel)]="form.data['address']">
              </textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm ml-2" (click)="save()" [disabled]="!uiForm.valid"
          title="Save">
          <i class="fa fa-save"></i> Save
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal" title="Close">
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- data entry form End -->

<!-- Filter Modal -->
<div class="modal fade" id="scrollableModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Search</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <label for="name" class="col-sm-3 col-form-label">Name:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control" id="name" placeholder="Enter name"
                [(ngModel)]="form.searchParams['name']" />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <label for="skey" class="col-sm-3 col-form-label">Key:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control" id="skey" name="skey" placeholder="Enter key"
                [(ngModel)]="form.searchParams['skey']" />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <label for="address" class="col-sm-3 col-form-label">Address:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control" id="address" name="address" placeholder="Enter address"
                [(ngModel)]="form.searchParams['address']" />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <label for="email" class="col-sm-3 col-form-label">Email:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control" id="email" name="email" placeholder="Enter email"
                [(ngModel)]="form.searchParams['email']" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2" title="Search"
          (click)="search()">
          Apply Filter
        </button>
        <button (click)="resetSearchForm()" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          title="Reset">
          <i class="fa fa-eraser" aria-hidden="true"></i>
        </button>
        <button type="button" title="Close" class="btn btn-outline-secondary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          data-bs-dismiss="modal">
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>